<template>
    <v-dialog v-model="dialogfilter" width="800px" scroll-strategy="none">
        <v-card :retain-focus="false" min-width="700px" class="pa-4 py-2"
            style="background-color:white; border-radius: 12px; overflow-y: hidden;">
            <h1>{{ $t('ColumnFilter.searchBy', { itm: title }) }}</h1>

            <div class="row">
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">
                            {{ $t('clients.userName') }}
                        </v-card-title>
                    </div>
                    <v-text-field v-model="filterParams.userName" id="UserName" name="UserName" maxlength="50"
                        hide-details persistent-placeholder
                        :placeholder="$t('placeholder.enter', { itm: $t('clients.userName') })" variant="outlined"
                        class="mt-n4"></v-text-field>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">
                            {{ $t('clients.typeOfBusiness') }}
                        </v-card-title>
                    </div>
                    <v-text-field v-model="filterParams.typeOfBusiness" id="Title" name="Title" maxlength="30"
                        hide-details persistent-placeholder
                        :placeholder="$t('placeholder.enter', { itm: $t('clients.typeOfBusiness') })" variant="outlined"
                        class="mt-n4"></v-text-field>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">
                            {{ $t('clients.address') }}
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="filterParams.address" id="Title" name="Title" maxlength="30" hide-details
                            persistent-placeholder
                            :placeholder="$t('placeholder.enter', { itm: $t('clients.address') })" variant="outlined"
                            class="mt-n4"></v-text-field>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">
                            {{ $t('clients.companyName') }}
                        </v-card-title>
                    </div>
                    <div class="row">
                        <v-text-field v-model="filterParams.companyName" id="Title" name="Title" maxlength="30"
                            hide-details persistent-placeholder
                            :placeholder="$t('placeholder.enter', { itm: $t('clients.companyName') })"
                            variant="outlined" class="mt-n4"></v-text-field>
                    </div>
                </div>
                <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">
                            {{ $t('clients.creationDate') }}
                        </v-card-title>
                    </div>
                    <dateField id="CreationDate" name="CreationDate" v-model="CreationDate"
                        :min-date="new Date('2000-01-01')" :max-date="new Date()" :model-value="CreationDate"
                        range-enabled @update:model-value="handleDateRangeCreationDate" class="mt-n4"
                        ref="creationDateRef" position="top" />
                </div>
                <div class="col-12 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left ma-3 pl-0 custom-card-title">
                            {{ $t('clients.status') }}
                        </v-card-title>
                    </div>
                    <div class="d-flex align-items-center mt-n4" style="justify-content: center;">
                        <v-checkbox v-for="(label, index) in statusLabels" :key="index" v-model="ValidationStatus"
                            :label="label" :value="index" class="mr-4" />
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center align-items-center">
                <card-actions :yes="confirm" v-model="dialogfilter" :no="dialogfilter" width="100px"
                    :yesTitle="$t('ColumnFilter.search')" @update:no="cancel">
                    <template v-slot:centerButton>
                        <genericBtnComponent width="100px" :ClickFun="cleardialogfilter"
                            :Title="$t('clients.clearBtn')" />
                    </template>
                </card-actions>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import cardActions from "@/genericComponent/cardActions.vue";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import dateField from "@/genericComponent/date-field.vue";

export default {
    components: {
        dateField,
        cardActions,
        genericBtnComponent
    },
    data() {
        return {
            filterParams: {
                userName: null,
                typeOfBusiness: null,
                address: null,
                companyName: null,
                CreatedFrom: null,
                CreatedTo: null,
            },
            dialogfilter: true,
            CreationDate: [],
            ValidationStatus: [],
            creationDateRef: null,
        };
    },
    methods: {
        confirm() {
            this.$emit('update:filteredclients',
                this.filterParams.userName,
                this.filterParams.typeOfBusiness,
                this.filterParams.address,
                this.filterParams.companyName,
                this.filterParams.CreatedFrom,
                this.filterParams.CreatedTo,
                this.ValidationStatus,
            );
        },
        cancel() {
            this.$emit('cancel');
        },
        cleardialogfilter() {
            this.filterParams.userName = null;
            this.filterParams.typeOfBusiness = null;
            this.filterParams.address = null;
            this.filterParams.companyName = null;
            this.filterParams.DeadlineFrom = null;
            this.filterParams.DeadlineTo = null;
            this.filterParams.CreatedFrom = null;
            this.filterParams.CreatedTo = null;
            this.CreationDate = [];
            this.ValidationStatus = [];
            if (this.$refs.creationDateRef) {
                this.$refs.creationDateRef.clearDateRange();
            }
        },
        handleDateRangeCreationDate(value) {
            if (Array.isArray(value) && value.length === 2) {
                this.filterParams.CreatedFrom = value[0];
                this.filterParams.CreatedTo = value[1];
            }
        },
    },
    computed: {
        isToValidateByAdmin() {
            return this.$t('clients.statusList.toBeValidatedByAdmin');
        },
        isToCorrect() {
            return this.$t('clients.statusList.toCorrect');
        },
        isRejected() {
            return this.$t('clients.statusList.rejected');
        },
        isCreated() {
            return this.$t('clients.statusList.created');
        },
        isValidatedCustomer() {
            return this.$t('clients.statusList.validatedCustomer');
        },
        statusLabels() {
            return [
                this.isCreated,
                this.isToCorrect,
                this.isToValidateByAdmin,
                this.isValidatedCustomer,
                this.isRejected
            ]
        }
    },

};
</script>

<style scoped>
h1 {
    font-family: inter;
    font-size: 18px;
    line-height: 29px;
    font-weight: 600;
    color: #0d0849;
    text-align: center;
}

.custom-card-title {
    font-size: 16px;
    color: #5b6d8e;
}

.error-message {
    color: red;
    font-size: 14px;
}
</style>